import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { COE_DOCUMENTS } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={COE_DOCUMENTS} id={id} />;
}

export const Route = createFileRoute("/_app/coe/documents/$id")({
  component: Edit,
});
